/** @jsxImportSource @emotion/react */
import React from "react";
import MediaManager from "../../../components/templates/MediaManager";

const ManageStorage: React.FC = () => {
  return <MediaManager initialFolder="banners" />;
};

export default ManageStorage;